const iconomicInfo = {
  COMPANY_NAME: 'Moank AB',
  EMAIL: 'kontakt@iconomic.se',
  PHONE: '08-520 059 55',
  ADDRESS: 'Box 3652, 103 59 Stockholm',
  STREET: 'Jakobsbergsgatan 13, våning 8',
};

export default iconomicInfo;
